import { styled } from 'styled-components';

export const Wrapper = styled.div`
    max-width: 400px;
    flex-wrap: wrap;
    display: flex;
    align-items: center;
    gap: 10px;
`;

export const DayToPayDate = styled.p`
    font-size: 14px;
    font-weight: 500;
    color: #00d9de;
`;
